/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { string as codecString } from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { BaseCouponWithoutCode } from './BaseCouponWithoutCode';
const TenantCouponWithoutCodeParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.object([
    ['scope', /* #__PURE__ */ parsers.exactly('tenant')],
    ['tenantId', codecString, 'tenant_id'],
]), BaseCouponWithoutCode);
export class TenantCouponWithoutCode extends BaseCouponWithoutCode {
    static decode(input) {
        return TenantCouponWithoutCodeParser.decode(input).map(res => new TenantCouponWithoutCode(res));
    }
    static unsafeDecode(input) {
        return TenantCouponWithoutCode.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return TenantCouponWithoutCodeParser.encode(data);
    }
    static schema() {
        return TenantCouponWithoutCodeParser.schema();
    }
}
